module.exports = __webpack_public_path__ + "img/MI_FE_3_capa_LA_mercado_2021_PF.20d2cb50.png";